import { $t } from "@/plugins/i18n";
import { aiVideo } from "@/router/enums";
import aiVideoIcon from "@/assets/svg/aiVideo.svg?component";
export default {
  path: "/aiVideo",
  meta: {
    title: $t("menus.aiVideo"), // 建议多语言
    rank: aiVideo,
    icon: aiVideoIcon,
    showLink: true,
    isNewMenu: true,
    // 侧边栏里以静态小标题 + 平铺子菜单的形式展示，不再折叠
    flatMenu: true
  },
  children: [
    // {
    //   path: "/qualificationReview/index",
    //   name: "qualificationReview",
    //   component: () => import("@/views/qualificationReview/index.vue"),
    //   meta: {
    //     title: $t("menus.qualificationReview")
    //     // keepAlive: false
    //   }
    // },
    // {
    //   path: "/talentPhoto/index",
    //   name: "talentPhoto",
    //   component: () => import("@/views/talentPhoto/index.vue"),
    //   meta: {
    //     title: $t("menus.talentPhoto")
    //     // keepAlive: false
    //   }
    // },
    {
      path: "/inspirationLibrary/index",
      name: "inspirationLibrary",
      component: () => import("@/views/InspirationLibrary/index.vue"),
      meta: {
        title: $t("menus.inspirationLibrary")
        // keepAlive: false
      }
    },
    {
      path: "/materialLibrary/index",
      name: "materialLibrary",
      component: () => import("@/views/materialLibrary/newIndex.vue"),
      meta: {
        title: $t("menus.materialLibrary")
        // keepAlive: false
      }
    },
    {
      path: "/storyboardLibrary/index",
      name: "storyboardLibrary",
      component: () => import("@/views/storyboardLibrary/index.vue"),
      meta: {
        title: $t("menus.storyboardLibrary")
        // keepAlive: false
      }
    },
    {
      path: "/modelLibrary/index",
      name: "modelLibrary",
      component: () => import("@/views/modelLibrary/index.vue"),
      meta: {
        title: $t("menus.modelLibrary")
        // keepAlive: false
      }
    },
    {
      path: "/productLibrary/index",
      name: "productLibrary",
      component: () => import("@/views/productLibrary/index.vue"),
      meta: {
        title: $t("menus.productLibrary")
        // keepAlive: false
      }
    },
    {
      path: "/aiImage/index",
      name: "aiImage",
      component: () => import("@/views/aiImage/index.vue"),
      meta: {
        title: $t("menus.aiImage")
        // keepAlive: false
      }
    },
    {
      path: "/celebritiesHelp/index",
      name: "celebritiesHelp",
      component: () => import("@/views/celebritiesHelp/index.vue"),
      meta: {
        title: $t("menus.celebritiesHelp")
        // keepAlive: false
      }
    }
    // {
    //   path: "/aIExpertVideo/index",
    //   name: "aIExpertVideo",
    //   component: () => import("@/views/aIExpertVideo/index.vue"),
    //   meta: {
    //     title: $t("menus.aIExpertVideo")
    //     // keepAlive: false
    //   }
    // },
    // {
    //   path: "/videoGenerationTask/index",
    //   name: "videoGenerationTask",
    //   component: () => import("@/views/videoGenerationTask/index.vue"),
    //   meta: {
    //     title: $t("menus.videoGenerationTask")
    //     // keepAlive: false
    //   }
    // }
  ]
} satisfies RouteConfigsTable;
